module.exports = "<div>\n  <router-outlet></router-outlet>\n</div>\n\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.html
// module id = ./src/app/app.component.html
// module chunks = main